import { useMemo } from 'react';
import { getTheme } from 'src/lib/theme-utils';

export const useVizTheme = () => {
  const theme = useMemo(getTheme, []);
  return theme === 'dark' ? 'Default' : 'Light';
};
